<template>
	<div class="u-bg-lines-topdown u-padd-top-half">
		<div class="variation-container max-width-xxl u-mrg-center wrapper" id="product-variations">
			<h4 class="h h-sm">Product Variations &amp; Specifications</h4>
            <div v-for="(product, index) in products" :key="`product_${index}`">
                <div class="u-mrg-center max-width-xxl ">
                    <div class="grid">
                         <div class="grid-item grid-item-w50@md grid-item-w25@lg">
                             <h3 class="u-txt-center u-mrg-top-none">{{product.name}}</h3>
                             <div class=" u-bg-color-white w100 u-padd-all ">
                             <img :src="product.Thumbnail" :alt="product.name" />
                             </div>
                         </div>
                        <div class="grid-item grid-item-w50@md grid-item-w75@lg">
                            <ag-product-variation-grid :product="product" sort-by="itemNumber" highlight-column="AttributeLabel2"></ag-product-variation-grid>
                        </div>
                    </div>
                </div>

            </div>
		</div>			
	</div>
</template>

<script>
import AgProductVariationGrid from './AgProductVariationGrid.vue';
export default {
	components: { AgProductVariationGrid },
	props: {},
	data() {
		return {
			products: [],
			selectedItem: null,
			currentPage: 1,
			totalItems: null,
			totalShowing: 5,
			increment: 10,
		};
	},
	created() {
		//or can pull path from a prop passed into the component
	},
	mounted() {
		this.setGallery(window.agProducts);
		this.getGalleryContent();
	},
	methods: {
		setGallery(response) {
			this.products = response;
			// this.totalItems = parseInt(response.length);
			this.getGalleryContent();
		},
		getGalleryContent() {
			this.loading = true;
		},
		loadMore() {
            /*
			if (this.totalShowing >= this.totalItems) return;
			this.totalShowing =
				this.totalShowing + this.increment >= this.totalItems
					? this.totalItems
					: this.totalShowing + this.increment;
                    */
		},
		viewAll() {
			// this.totalShowing = this.totalItems;
		},
	},
    /*
	computed: {
		filteredItems() {
			return this.products.slice(0, this.totalShowing).map((item) => {
				return item;
			});
		},
	},
    */
};
</script>
